module.exports = __webpack_public_path__ + "static/img/Summer_copy.30c72c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/june/Summer_copy.png
// module id = /pjQ
// module chunks = 4